import { render, staticRenderFns } from "./people-filter.vue?vue&type=template&id=8aa1e3be&scoped=true"
import script from "./people-filter.vue?vue&type=script&lang=js"
export * from "./people-filter.vue?vue&type=script&lang=js"
import style0 from "./people-filter.vue?vue&type=style&index=0&id=8aa1e3be&prod&lang=scss&scoped=true"
import style1 from "./people-filter.vue?vue&type=style&index=1&id=8aa1e3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa1e3be",
  null
  
)

export default component.exports